"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modelProperties = { modelName: 'AccountVerification', tableName: 'AccountVerification', global: true };
exports.default = modelProperties;
//# sourceMappingURL=../../../../src/models/accountVerification/modelProperties.js.map